import { gql } from '@apollo/client';

export const SEAT_UPGRADE_PREVIEW = gql`
  query SeatUpgradePreview($subscriptionId: ID!, $seatsS: Int!, $seatsM: Int!, $seatsL: Int!) {
    seatUpgradePreview(subscriptionId: $subscriptionId, seatsS: $seatsS, seatsM: $seatsM, seatsL: $seatsL) {
      grossTotal
      taxAmount
      breakdown { seatType total }
    }
  }
`; 